"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceMethods = exports.ServiceHelper = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@bimser/common");
const components_1 = require("@bimser/components");
const core_1 = require("@bimser/core");
const cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
class ServiceHelper {
    static getDataSourceColumns({ projectName, dsFileName, dsfileId, columnFilter, acceptArray, dataSourceName, cache = false, columns = [], getDataSourceContent }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield getDataSourceContent({
                    info: { projectName },
                    dataSource: { name: dsFileName || dataSourceName, fileId: dsfileId },
                    cache,
                    columnFilter,
                    acceptArray
                });
                const items = (0, cloneDeep_1.default)(result.columns);
                columns.forEach(column => {
                    if (!items.some(item => item.value == column.value)) {
                        items.push(column);
                    }
                });
                return {
                    allow: true,
                    options: items
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static getDataSourceColumnsAsTree({ projectName, dsFileName, dsfileId, cache = false, columnFilter, acceptArray, selectableAll, dataSourceName, parentPath, getDataSourceContent }) {
        return new Promise(resolve => {
            getDataSourceContent({
                info: { projectName },
                dataSource: { name: dsFileName || dataSourceName, fileId: dsfileId },
                cache,
                columnFilter,
                acceptArray
            })
                .then(result => {
                const convertItems = (items, currentValue) => {
                    const obj = {};
                    items.forEach(i => (obj[i.value] = true));
                    const isMLObject = core_1.MLHelper.isMLObject(obj);
                    const newItems = items.map(i => {
                        var _a, _b;
                        return ({
                            selectable: selectableAll || !((_a = i.items) === null || _a === void 0 ? void 0 : _a.length),
                            key: i.key,
                            title: i.text,
                            value: i.key,
                            children: ((_b = i.items) === null || _b === void 0 ? void 0 : _b.length) ? convertItems(i.items, i.key) : []
                        });
                    });
                    if (isMLObject) {
                        newItems.push({
                            selectable: selectableAll || true,
                            key: currentValue
                                ? currentValue + '.__userCulture'
                                : '__userCulture',
                            title: components_1.findMessage.get('101079'),
                            value: currentValue
                                ? currentValue + '.__userCulture'
                                : '__userCulture',
                            children: []
                        });
                    }
                    return newItems;
                };
                let newItems = result.columns;
                if (parentPath) {
                    const getItems = (items) => {
                        const datas = [];
                        items.forEach(item => {
                            if (item.key == parentPath) {
                                const convertItems = (_items, currentKey) => _items.map(i => {
                                    var _a;
                                    return (Object.assign(Object.assign({}, i), { key: currentKey
                                            ? currentKey + '.' + i.name
                                            : i.name, items: ((_a = i.items) === null || _a === void 0 ? void 0 : _a.length)
                                            ? convertItems(i.items, i.name)
                                            : [] }));
                                });
                                newItems = convertItems(item.items);
                            }
                            if (item === null || item === void 0 ? void 0 : item.items) {
                                getItems(item.items);
                            }
                            else {
                                return;
                            }
                        });
                        return datas;
                    };
                    getItems(result.columns);
                }
                const options = convertItems(newItems);
                resolve({
                    allow: true,
                    options
                });
            })
                .catch(() => {
                resolve({
                    allow: true,
                    options: []
                });
            });
        });
    }
    static getDataSourceColumnsAsTreeOnlyFirstLevel({ projectName, dsFileName, dsfileId, cache = false, columnFilter, acceptArray, dataSourceName, getDataSourceContent }) {
        return new Promise(resolve => {
            getDataSourceContent({
                info: { projectName },
                dataSource: { name: dsFileName || dataSourceName, fileId: dsfileId },
                cache,
                columnFilter,
                acceptArray
            })
                .then(result => {
                const convertItems = (items, currentValue) => {
                    const obj = {};
                    items.forEach(i => (obj[i.value] = true));
                    const isMLObject = core_1.MLHelper.isMLObject(obj);
                    const newItems = items.map(i => ({
                        selectable: true,
                        key: i.key,
                        title: i.text,
                        value: i.key
                    }));
                    if (isMLObject) {
                        newItems.push({
                            selectable: true,
                            key: currentValue
                                ? currentValue + '.__userCulture'
                                : '__userCulture',
                            title: components_1.findMessage.get('101079'),
                            value: currentValue
                                ? currentValue + '.__userCulture'
                                : '__userCulture',
                            children: []
                        });
                    }
                    return newItems;
                };
                const options = convertItems(result.columns);
                resolve({
                    allow: true,
                    options
                });
            })
                .catch(() => {
                resolve({
                    allow: true,
                    options: []
                });
            });
        });
    }
    static getCustomMetadataName() {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.hr.Properties.GetPropertiesWithRelation.callPromise({ OSID: 1 }, true, {
                    cache: true
                });
                const items = result.map(({ propertyTypeName, propertyType }) => ({
                    key: propertyTypeName,
                    text: propertyTypeName,
                    name: propertyTypeName,
                    value: propertyTypeName,
                    externalData: {
                        propertyType
                    }
                }));
                return {
                    allow: true,
                    options: items
                };
            }
            catch (err) {
                console.log(err);
                const errorText = common_1.ErrorCodes[common_1.MainUtils.getTaleInnerException((_b = (_a = err === null || err === void 0 ? void 0 : err.exception) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.exception)];
                if (errorText) {
                    common_1.MessageBox.error({
                        title: components_1.findMessage.get('100926'),
                        content: errorText,
                        buttons: common_1.MessageBoxButtons.OK,
                        errorCode: `Code : ${err.code} | FootPrint : ${err.footPrint}`
                    });
                }
                return { allow: true, options: [] };
            }
        });
    }
    static getProjectsWhereActionFormExist({ name = 'id', cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetProjectsWhereActionFormExist.callPromise({}, null, { cache });
                const items = result.projects.map(item => ({
                    key: item[name],
                    text: item.name,
                    name: item.name,
                    value: item[name],
                    externalData: {
                        propertyType: item.id
                    }
                }));
                return { allow: true, options: items };
            }
            catch (err) {
                console.log(err);
                return { allow: true, options: [] };
            }
        });
    }
    static getProjects({ currentProjectSecretKey, currentProjectName, name = 'id', cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetProjects.callPromise({}, null, { cache });
                const items = result.projects.map(item => {
                    const option = {
                        key: item[name],
                        text: item.name,
                        name: item.name,
                        value: item[name],
                        externalData: {
                            propertyType: item.id,
                            projectSecretKey: item.secretKey
                        }
                    };
                    if (option.name === currentProjectName) {
                        option.externalData.projectSecretKey = currentProjectSecretKey;
                    }
                    return option;
                });
                return { allow: true, options: items };
            }
            catch (err) {
                console.log(err);
                return { allow: true, options: [] };
            }
        });
    }
    static getForms({ currentProjectSecretKey, currentProjectName, projectName, cache = false, formType = undefined, name = 'id' }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!projectName) {
                    throw new Error('projectName is required');
                }
                const { options } = yield ServiceHelper.getProjects({
                    currentProjectName,
                    currentProjectSecretKey,
                    name,
                    cache: true
                });
                const project = options.find(option => option.name === projectName);
                if (!project) {
                    throw new Error('project not found');
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetForms.callPromise({
                    projectSecretKey: project.externalData.projectSecretKey,
                    formType,
                    includeDeleted: true
                }, true, { cache });
                const items = result.forms.map(item => ({
                    key: item[name],
                    text: item.name,
                    name: item.name,
                    value: item[name],
                    externalData: {
                        id: item.id,
                        propertyType: item.id
                    }
                }));
                return { allow: true, options: items };
            }
            catch (e) {
                console.log(e);
                return { allow: true, options: [] };
            }
        });
    }
    static getViews({ currentProjectSecretKey, currentProjectName, projectName, formId, formName = null, cache = false, name = 'id' }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!projectName) {
                    throw new Error('projectName is required');
                }
                if (!formId) {
                    if (!formName) {
                        throw new Error('formName is required');
                    }
                    const { options: forms } = yield ServiceHelper.getForms({
                        currentProjectSecretKey,
                        currentProjectName,
                        projectName,
                        cache,
                        name
                    });
                    const form = forms.find(f => f.name === formName);
                    if (!form) {
                        throw new Error('form not found');
                    }
                    formId = form.externalData.id;
                }
                if (!formId) {
                    throw new Error('formId is required');
                }
                const { options: projects } = yield ServiceHelper.getProjects({
                    currentProjectSecretKey,
                    currentProjectName,
                    name,
                    cache: true
                });
                const project = projects.find(p => p.name === projectName);
                if (!project) {
                    throw new Error('project not found');
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetViews.callPromise({
                    formId,
                    projectSecretKey: project.externalData.projectSecretKey,
                    includeDeleted: true
                }, true, {
                    cache
                });
                const items = result.views.map(item => ({
                    key: item[name],
                    text: item.name,
                    name: item.name,
                    value: item[name],
                    externalData: {
                        propertyType: item.id
                    }
                }));
                return { allow: true, options: items };
            }
            catch (err) {
                console.log(err);
                return { allow: true, options: [] };
            }
        });
    }
    static getFlows({ currentProjectSecretKey, currentProjectName, projectName, cache = false, name = 'id', projectId = null }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!projectName && !projectId) {
                    throw new Error('projectName or projectId must be provided');
                }
                const { options } = yield ServiceHelper.getProjects({
                    currentProjectSecretKey,
                    currentProjectName,
                    name,
                    cache: true
                });
                let project;
                if (projectName) {
                    project = options.find(option => option.name === projectName);
                }
                else {
                    project = options.find(option => option.externalData.propertyType === projectId);
                }
                if (!project) {
                    throw new Error('project not found');
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetFlows.callPromise({ projectSecretKey: project.externalData.projectSecretKey, includeDeleted: true }, true, { cache });
                const items = result.flows.map(item => ({
                    key: item[name],
                    text: item.name,
                    name: item.name,
                    value: item[name],
                    externalData: { propertyType: item.id }
                }));
                return { allow: true, options: items };
            }
            catch (_a) {
                return { allow: true, options: [] };
            }
        });
    }
    static getProjectReports({ projectName, cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!projectName) {
                    throw new Error('projectName is required');
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetProjectReports.callPromise({ projectName }, null, { cache });
                const items = result.reports.map(({ reportId, reportName, parameters }) => ({
                    key: reportId,
                    text: reportName,
                    name: reportName,
                    value: reportId,
                    externalData: {
                        parameters: parameters.map(({ dataSourceParameter, name, allowNull, type }) => ({
                            name,
                            allowNull,
                            type,
                            path: '',
                            parameterType: dataSourceParameter ? 'dynamic' : 'static'
                        }))
                    }
                }));
                return {
                    allow: true,
                    options: items
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static setReportParameters({ projectName, formName, viewName, serviceUrl, parameters, reportId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield common_1.HTTPRequest.post(`${serviceUrl}/project/forms/GetFormInfoByName`, {
                    projectName: projectName,
                    formName: formName,
                    view: viewName,
                    parameters: {}
                });
                const { data } = yield common_1.HTTPRequest.post(`${response.data.deploymentUrl}apps/${projectName}/latest/api/ReportViewer/SetReportParameters`, {
                    parameters,
                    reportId
                }, { cache: false });
                return data;
            }
            catch (err) {
                console.log(err);
                return '';
            }
        });
    }
    static getDataTypes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.main.DataSecurity.GetSecurityDataTypes.callPromise({
                    loadOptions: {
                        pagination: {
                            skip: 0,
                            take: 9999
                        }
                    }
                });
                return {
                    allow: true,
                    options: result.securityDataTypes.map(({ id, name }) => ({
                        key: id.toString(),
                        text: core_1.MLHelper.getMLText(name),
                        value: id
                    }))
                };
            }
            catch (_a) {
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static getManagerKeys({ cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.hr.ManagerKeys.GetAll.callPromise(false, { cache });
                return {
                    allow: true,
                    options: result.map(({ id, description }) => ({
                        key: id.toString(),
                        text: description,
                        value: id
                    }))
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static getProfiles({ cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield common_1.ServiceList.web.MailService.GetProfiles.callPromise(false, {
                    cache
                });
                return {
                    allow: true,
                    options: result.map(({ profileName, isDefault }) => ({
                        key: profileName,
                        text: profileName,
                        value: profileName,
                        selected: isDefault
                    }))
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static getProjectQueries({ projectName, filterConnectionType, cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield common_1.ServiceList.Studio.DataSource.Query.GetProjectQueries.callPromise({ projectName }, null, { cache });
                if (filterConnectionType) {
                    result = result.filter(i => i.connectionType == filterConnectionType);
                }
                return {
                    allow: true,
                    options: result.map(({ id, name }) => ({ key: id, value: id, text: name })),
                    properties: result.map(({ properties }) => properties),
                    structure: result.map(({ structure }) => structure)
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: [],
                    properties: [],
                    structure: []
                };
            }
        });
    }
    static getFormFieldsByControlType({ projectSecretKey, currentProjectSecretKey, projectName, currentProjectName, controlType, formId, cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!projectSecretKey && !projectName) {
                    throw new Error('Project secret key and project name infos must be provided.');
                }
                if (!projectSecretKey) {
                    const { options } = yield ServiceHelper.getProjects({
                        currentProjectSecretKey,
                        currentProjectName
                    });
                    const project = options.find(option => option.name === projectName);
                    if (!project) {
                        throw new Error('Project not found');
                    }
                    projectSecretKey = project.externalData.projectSecretKey;
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetFormFieldsByControlType.callPromise({ formId, controlType, projectSecretKey, includeDeleted: true }, null, { cache });
                return {
                    allow: true,
                    options: result.fields.map(({ id, name }) => ({
                        key: id,
                        value: id,
                        text: name
                    }))
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
    static getFormFields({ currentProjectName, currentProjectSecretKey, projectName, formId, cache = false }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!formId) {
                    throw new Error('formId is required');
                }
                const { options } = yield ServiceHelper.getProjects({
                    currentProjectName,
                    currentProjectSecretKey,
                    cache: true
                });
                const project = options.find(option => option.name === projectName);
                if (!project) {
                    throw new Error('project not found');
                }
                const result = yield common_1.ServiceList.Studio.ProjectManager.GetFormFieldsForArchive.callPromise({ formId, projectSecretKey: project.externalData.projectSecretKey }, null, {
                    cache
                });
                return {
                    allow: true,
                    options: result.fields.map(({ name }) => ({ key: name, value: name, text: name }))
                };
            }
            catch (err) {
                console.log(err);
                return {
                    allow: true,
                    options: []
                };
            }
        });
    }
}
exports.ServiceHelper = ServiceHelper;
var ServiceMethods;
(function (ServiceMethods) {
    ServiceMethods["getCustomMetadataName"] = "getCustomMetadataName";
    ServiceMethods["getDataSourceColumns"] = "getDataSourceColumns";
    ServiceMethods["getDataSourceColumnsAsTree"] = "getDataSourceColumnsAsTree";
    ServiceMethods["getDataSourceColumnsAsTreeOnlyFirstLevel"] = "getDataSourceColumnsAsTreeOnlyFirstLevel";
    ServiceMethods["getProjectsWhereActionFormExist"] = "getProjectsWhereActionFormExist";
    ServiceMethods["getProjects"] = "getProjects";
    ServiceMethods["getForms"] = "getForms";
    ServiceMethods["getFlows"] = "getFlows";
    ServiceMethods["getViews"] = "getViews";
    ServiceMethods["getProjectReports"] = "getProjectReports";
    ServiceMethods["getDataTypes"] = "getDataTypes";
    ServiceMethods["getFormFields"] = "getFormFields";
    ServiceMethods["getManagerKeys"] = "getManagerKeys";
    ServiceMethods["getProfiles"] = "getProfiles";
    ServiceMethods["getProjectQueries"] = "getProjectQueries";
    ServiceMethods["getFormFieldsByControlType"] = "getFormFieldsByControlType";
})(ServiceMethods || (exports.ServiceMethods = ServiceMethods = {}));
//# sourceMappingURL=index.js.map